export enum AudioMix {
  Mix_1_0 = "Mix_1_0",
  Mix_2_0 = "Mix_2_0",
  Mix_5_1 = "Mix_5_1",
  Mix_7_1 = "Mix_7_1",
  Mix_1_0_1_0 = "Mix_1_0_1_0",
  Undefined = "Undefined",
}
